import React, { useEffect, useState } from "react";
import Box from "../../../../components/box/Box";
import user from "./users.png";
import Bargraph from "../../../../components/Graph/Bargraph";
import Smallbar from "../../../../components/Smallbar/Smallbar";
import PieChart from "../../../../components/Pie/PieChart";
import data from "./Data";
import Table from "../../../../components/Table/Table";
import Team from "./Team/Team";
import Student from "./Student/Student";
import { startOfWeek, endOfWeek, subDays, format } from "date-fns";

import Trainer from "./Trainer/Trainer";
import "./Admindash.css";
import TrainerTable from "../../../../components/Trainer/TrainerTable";
import { getTeamMembersEarnings } from "../../../../service/getUsersEarnings/getTeamMembersEarnings";
import { getTeamLeadersEarnings } from "../../../../service/getUsersEarnings/getTeamLeadersEarnings";
import { getClubTrainersEarnings } from "../../../../service/getUsersEarnings/getClubTrainersEarnings";
import { getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../../../../firebase-config";
const SuperDa = () => {
  const [showTeam, setShowTeam] = useState(false);
  const [showStudent, setShowStudent] = useState(false);
  const [showTrainer, setShowTrainer] = useState(false);
  const [teamLeadersEarnings, setTeamLeadersEarnings] = useState([]);
  const [teamMembersEarnings, setTeamMembersEarnings] = useState([]);
  const [clubTrainersEarnings, setClubTrainersEarnings] = useState([]);
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalUsersGrowth: 0,
    totalTeamLeaders: 0,
    teamLeaderGrowth: 0,
    totalTeamMembers: 0,
    teamMemberGrowth: 0,
  });

  useEffect(() => {
    const fetchEarnings = async () => {
      const teamLeadersEarnings = await getTeamLeadersEarnings();
      setTeamLeadersEarnings(teamLeadersEarnings);

      const teamMembersEarnings = await getTeamMembersEarnings();
      setTeamMembersEarnings(teamMembersEarnings);

      const clubTrainersEarnings = await getClubTrainersEarnings();
      setClubTrainersEarnings(clubTrainersEarnings);
    };

    fetchEarnings();
  }, []);
  const ShowTeam = () => {
    setShowTeam(true);
    setShowStudent(false);
    setShowTrainer(false);
  };

  const ShowStudent = () => {
    setShowTeam(false);
    setShowStudent(true);
    setShowTrainer(false);
  };

  const ShowTrainer = () => {
    setShowTeam(false);
    setShowStudent(false);
    setShowTrainer(true);
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        if (snapshot.empty) return;

        const users = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // start of today
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);

        // yesterday
        const startOfYesterday = new Date(startOfToday);
        startOfYesterday.setDate(startOfYesterday.getDate() - 1);

        // --- Helpers ---
        const parseDate = (createdAt) => {
          if (!createdAt) return null;
          const [day, month, year] = createdAt.split(" ")[0].split("-");
          return new Date(`20${year}-${month}-${day}`);
        };

        // --- Total Users ---
        const totalUsers = users.length;

        const totalUsersYesterday = users.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        const totalUsersGrowth = totalUsersYesterday
          ? ((totalUsers - totalUsersYesterday) / totalUsersYesterday) * 100
          : 0;

        // --- Team Leader / Team Member Counts ---
        const teamLeaders = users.filter((u) => u.userTypes === "team_leader");
        const teamMembers = users.filter((u) => u.userTypes === "team_member");

        const totalTeamLeaders = teamLeaders.length;
        const totalTeamMembers = teamMembers.length;

        // Yesterday counts
        const teamLeadersYesterday = teamLeaders.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        const teamMembersYesterday = teamMembers.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        // Growth %
        const teamLeaderGrowth = teamLeadersYesterday
          ? ((totalTeamLeaders - teamLeadersYesterday) / teamLeadersYesterday) *
            100
          : 0;

        const teamMemberGrowth = teamMembersYesterday
          ? ((totalTeamMembers - teamMembersYesterday) / teamMembersYesterday) *
            100
          : 0;

        // --- Final Stats ---
        setStats({
          totalUsers,
          totalUsersGrowth: totalUsersGrowth.toFixed(1),
          totalTeamLeaders,
          teamLeaderGrowth: teamLeaderGrowth.toFixed(1),
          totalTeamMembers,
          teamMemberGrowth: teamMemberGrowth.toFixed(1),
        });
      } catch (e) {
        console.error("Error fetching user stats:", e);
      }
    };

    fetchStats();
  }, []);

  const [weeksData, setWeeksData] = useState([]);

  useEffect(() => {
    const fetchUsersJoinedEveryWeek = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        if (snapshot.empty) return;

        const users = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Helper to parse createdAt string (format: DD-MM-YY HH:MM)
        const parseDate = (createdAt) => {
          const [day, month, year] = createdAt.split(" ")[0].split("-");
          return new Date(`20${year}-${month}-${day}`);
        };

        // Today at midnight
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Generate last 6 weeks ranges
        const weeks = [];
        for (let i = 5; i >= 0; i--) {
          const start = new Date(today);
          start.setDate(today.getDate() - (i + 1) * 7);
          start.setHours(0, 0, 0, 0);

          const end = new Date(today);
          end.setDate(today.getDate() - i * 7);
          end.setHours(0, 0, 0, 0);

          weeks.push({ start, end });
        }

        // Count new users per week
        const newUsersPerWeek = weeks.map(
          ({ start, end }) =>
            users.filter(
              (u) =>
                u.createdAt &&
                parseDate(u.createdAt) >= start &&
                parseDate(u.createdAt) < end
            ).length
        );
        setWeeksData(newUsersPerWeek);
      } catch (e) {
        console.error("Error fetching user stats:", e);
      }
    };
    fetchUsersJoinedEveryWeek();
  }, []);

  const [amountstats, setAmountStats] = useState({
    totalRevenue: 0,
    dailyRevenue: {},
    todayRevenue: 0,
    yesterdayRevenue: 0,
    growth: "0%",
  });

  useEffect(() => {
    const fetchRevenueStats = async () => {
      try {
        const snapshot = await getDocs(collection(db, "transactions"));
        if (snapshot.empty) {
          setStats((prev) => ({ ...prev }));
          return;
        }

        const transactions = snapshot.docs.map((doc) => ({
          ...doc.data(),
          amount: Number(doc.data().amount),
          createdAt: doc.data().createdAt.toDate
            ? doc.data().createdAt.toDate()
            : new Date(doc.data().createdAt),
        }));

        // ---- Total revenue ----
        const totalRevenue = transactions.reduce((sum, t) => sum + t.amount, 0);

        // ---- Weekly revenue by day ----
        const now = new Date();
        const start = startOfWeek(now, { weekStartsOn: 1 });
        const end = endOfWeek(now, { weekStartsOn: 1 });

        const weekTransactions = transactions.filter(
          (t) => t.createdAt >= start && t.createdAt <= end
        );

        const dailyRevenue = {};
        for (let d = 0; d < 7; d++) {
          const day = new Date(start);
          day.setDate(start.getDate() + d);
          const dayKey = format(day, "yyyy-MM-dd");

          const totalForDay = weekTransactions
            .filter((tx) => format(tx.createdAt, "yyyy-MM-dd") === dayKey)
            .reduce((sum, tx) => sum + tx.amount, 0);

          dailyRevenue[dayKey] = totalForDay;
        }

        // ---- Yesterday vs Today growth ----
        const todayKey = format(now, "yyyy-MM-dd");
        const yesterdayKey = format(subDays(now, 1), "yyyy-MM-dd");

        const todayRevenue = dailyRevenue[todayKey] || 0;
        const yesterdayRevenue = dailyRevenue[yesterdayKey] || 0;

        let growthStr = "0%";
        if (yesterdayRevenue === 0 && todayRevenue === 0) {
          growthStr = "0%";
        } else if (yesterdayRevenue === 0 && todayRevenue > 0) {
          growthStr = " 100";
        } else {
          const growth =
            ((todayRevenue - yesterdayRevenue) / yesterdayRevenue) * 100;
          const rounded = growth.toFixed(2);
          growthStr = growth >= 0 ? ` ${rounded}` : ` ${Math.abs(rounded)}`;
        }

        setAmountStats({
          totalRevenue,
          dailyRevenue,
          todayRevenue,
          yesterdayRevenue,
          growth: growthStr,
        });
      } catch (err) {
        console.error("Error fetching transactions:", err);
      }
    };

    fetchRevenueStats();
  }, []);

  if (showTeam) {
    return <Team />;
  } else if (showStudent) {
    return <Student />;
  } else if (showTrainer) {
    return <Trainer />;
  }

  return (
    <div className="admindash">
      <h1 className="heading">Dashboard</h1>

      <div className="boxes flex gap-4 w-full max-w-[100%]">
        <Box
          subhed={"User"}
          value={stats?.totalUsers}
          growth={stats?.totalUsersGrowth}
          logo={user}
        />
        <Box
          subhed={"Team Leader"}
          value={stats?.totalTeamLeaders}
          growth={stats?.teamLeaderGrowth}
          logo={user}
        />
        <Box
          subhed={"Team Member"}
          value={stats?.totalTeamMembers}
          growth={stats?.teamMemberGrowth}
          logo={user}
        />
        <Box
          subhed={"Amount"}
          value={"$" + amountstats?.totalRevenue}
          growth={amountstats?.growth}
          logo={user}
        />
      </div>

      <div className="graphs">
        <Smallbar data={weeksData} />
        <PieChart
          data={[
            stats.totalUsers,
            stats.totalTeamLeaders,
            stats.totalTeamMembers,
          ]}
          labels={["Red", "Blue", "Yellow"]}
        />
        <Bargraph data={amountstats.dailyRevenue} />
      </div>

      <div className="tables">
        <div className="hes">
          <h1 className="heading">Club Members</h1>
          <h2 className="subha" onClick={ShowTeam}>
            View All
          </h2>
        </div>
        <Table
          data={teamMembersEarnings}
          onViewFull={() => {}}
          showAction={false}
        />

        <div className="hes">
          <h1 className="heading">Club Leaders</h1>{" "}
          <h2 className="subha" onClick={ShowStudent}>
            View All
          </h2>
        </div>
        <Table
          data={teamLeadersEarnings}
          onViewFull={() => {}}
          showAction={false}
        />

        <div className="hes">
          <h1 className="heading">Trainer</h1>{" "}
          <h2 className="subha" onClick={ShowTrainer}>
            View All
          </h2>
        </div>
        {/* <TrainerTable data={data} onViewFull={() => { }} showAction={true} /> */}
        <Table
          data={clubTrainersEarnings}
          onViewFull={() => {}}
          showAction={false}
        />
      </div>
    </div>
  );
};

export default SuperDa;
